// src/redux/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import toolReducer from './tool/toolSlice';
import breadcrumbsReducer from './Admin/breadcrumbsSlice';
import companyViewReducer from './Admin/companyViewSlice';
import employeeViewReducer from './Admin/employeeViewSlice';
import coachReducer from './Coach/coachSlice';
import authReducer from './auth/authSlice';
import supportedDocumentsReducer from './SupportedDocuments/supportedDocumentsSlice';
import assignmentsReducer from './Assignment/assignmentsSlice';
import countryReducer from './countryStateCity/cityStateCountrySlice';
import sessionReducer from './SessionMaster/sessionMasterSlice';
import companiesReducer from './Companies/companiesSlice';
import employeesReducer from './Employee/employeesSlice';
import batchesReducer from "./Batches/batchSlice";
import managementsReducer from "./Managment/mangmentSlice";
import managementViewReducer from './Admin/managementViewSlice';
import sessionViewReducer from "./Admin/sessionViewSlice";
import companySessionReducer from "./CompanySession/companiesSessionSlice"
import interviewCandidateReducer from './InterViewCandidate/interViewCandidateSlice';
import companyAdhocReducer from "./AdhocCompany/Companyadhocslice"
import scienceOfSelfReducer from "./ScienceOfSelf/Scienceofselfslice"
import scienceOfSelfViewReducer from './Admin/scienceOfSelfViewSlice';
import salesTrainingCompaniesReducer from "./SalesTrainingCompanies/SalesTrainingCompaniesslice";
import salesTrainingViewReducer from './Admin/salesTrainingViewSlice';
import companyProspectReducer from "./ProspectCompany/companyProspectSlice";
import notificationReducer from "./Notification/Notificationslice";
import settingsReducer from "./Setting/Settingsslice";
import assessmentResultsReducer from "./AssessmentResults/assessmentResultsSlice";
import learningFeedbackReducer from "./LearningFeedback/learningFeedbackSlice";
import sessionUrlReducer from "./SessionUrl/sessionUrlSlice";
import publicCityReducer from "./PublicCity/publicCitySlice";
const rootReducer = combineReducers({
  tool: toolReducer,
  breadcrumb: breadcrumbsReducer,
  companyView: companyViewReducer,
  employeeView: employeeViewReducer,
  coach: coachReducer,
  auth: authReducer,
  supportedDocuments: supportedDocumentsReducer,
  assignments: assignmentsReducer,
  country: countryReducer,
  sessionMaster: sessionReducer,
  company: companiesReducer,
  employees: employeesReducer,
  batches: batchesReducer,
  managements: managementsReducer,
  managementView: managementViewReducer,
  sessionView: sessionViewReducer,
  companySession: companySessionReducer,
  interviewCandidate: interviewCandidateReducer,
  companyAdhoc: companyAdhocReducer,
  scienceOfSelf: scienceOfSelfReducer,
  scienceOfSelfView: scienceOfSelfViewReducer,
  salesTrainingCompanies: salesTrainingCompaniesReducer,
  salesTrainingView: salesTrainingViewReducer,
  companyProspect: companyProspectReducer,
  settings :settingsReducer,
notification : notificationReducer,
  assessmentResults: assessmentResultsReducer,
  learningFeedback: learningFeedbackReducer,
  sessionUrl: sessionUrlReducer,
  publicCity: publicCityReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  // persist auth (already) and companyView + employeeView so selected names survive refresh
  whitelist: ['auth', 'companyView', 'employeeView', 'managementView', "sessionView", "scienceOfSelfView", "salesTrainingView"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export default store;